export default "__VITE_ASSET__74963431__"